// 비지니스 헬퍼

// =================================================================================================
// 가져오기
// =================================================================================================
// 고정 영역

// 동적 영역
import storageHelper from './storageHelper';
import numericHelper from './numericHelper';
import objectHelper from './objectHelper';
import localizationHelper from './localizationHelper';
import logHelper from './logHelper';
import stringHelper from './stringHelper';

// =================================================================================================
// 상수
// =================================================================================================
// DISC 설문 정보
const discSurveyDataList = {
  1: [
    {
      questionNo: 1, // 질문번호
      discType: 'S', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_1_s.png', // 이미지 경로
    },
    {
      questionNo: 1, // 질문번호
      discType: 'D', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_1_d.png', // 이미지 경로
    },
    {
      questionNo: 1, // 질문번호
      discType: 'C', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_1_c.png', // 이미지 경로
    },
    {
      questionNo: 1, // 질문번호
      discType: 'I', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_1_i.png', // 이미지 경로
    },
  ],
  2: [
    {
      questionNo: 2, // 질문번호
      discType: 'D', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_2_d.png', // 이미지 경로
    },
    {
      questionNo: 2, // 질문번호
      discType: 'C', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_2_c.png', // 이미지 경로
    },
    {
      questionNo: 2, // 질문번호
      discType: 'I', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_2_i.png', // 이미지 경로
    },
    {
      questionNo: 2, // 질문번호
      discType: 'S', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_2_s.png', // 이미지 경로
    },
  ],
  3: [
    {
      questionNo: 3, // 질문번호
      discType: 'S', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_3_s.png', // 이미지 경로
    },
    {
      questionNo: 3, // 질문번호
      discType: 'I', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_3_i.png', // 이미지 경로
    },
    {
      questionNo: 3, // 질문번호
      discType: 'D', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_3_d.png', // 이미지 경로
    },
    {
      questionNo: 3, // 질문번호
      discType: 'C', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_3_c.png', // 이미지 경로
    },
  ],
  4: [
    {
      questionNo: 4, // 질문번호
      discType: 'D', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_4_d.png', // 이미지 경로
    },
    {
      questionNo: 4, // 질문번호
      discType: 'C', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_4_c.png', // 이미지 경로
    },
    {
      questionNo: 4, // 질문번호
      discType: 'S', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_4_s.png', // 이미지 경로
    },
    {
      questionNo: 4, // 질문번호
      discType: 'I', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_4_i.png', // 이미지 경로
    },
  ],
  5: [
    {
      questionNo: 5, // 질문번호
      discType: 'C', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_5_c.png', // 이미지 경로
    },
    {
      questionNo: 5, // 질문번호
      discType: 'I', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_5_i.png', // 이미지 경로
    },
    {
      questionNo: 5, // 질문번호
      discType: 'S', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_5_s.png', // 이미지 경로
    },
    {
      questionNo: 5, // 질문번호
      discType: 'D', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_5_d.png', // 이미지 경로
    },
  ],
  6: [
    {
      questionNo: 6, // 질문번호
      discType: 'I', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_6_i.png', // 이미지 경로
    },
    {
      questionNo: 6, // 질문번호
      discType: 'D', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_6_d.png', // 이미지 경로
    },
    {
      questionNo: 6, // 질문번호
      discType: 'C', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_6_c.png', // 이미지 경로
    },
    {
      questionNo: 6, // 질문번호
      discType: 'S', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_6_s.png', // 이미지 경로
    },
  ],
  7: [
    {
      questionNo: 7, // 질문번호
      discType: 'C', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_7_c.png', // 이미지 경로
    },
    {
      questionNo: 7, // 질문번호
      discType: 'S', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_7_s.png', // 이미지 경로
    },
    {
      questionNo: 7, // 질문번호
      discType: 'D', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_7_d.png', // 이미지 경로
    },
    {
      questionNo: 7, // 질문번호
      discType: 'I', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_7_i.png', // 이미지 경로
    },
  ],
  8: [
    {
      questionNo: 8, // 질문번호
      discType: 'I', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_8_i.png', // 이미지 경로
    },
    {
      questionNo: 8, // 질문번호
      discType: 'D', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_8_d.png', // 이미지 경로
    },
    {
      questionNo: 8, // 질문번호
      discType: 'C', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_8_c.png', // 이미지 경로
    },
    {
      questionNo: 8, // 질문번호
      discType: 'S', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_8_s.png', // 이미지 경로
    },
  ],
  9: [
    {
      questionNo: 9, // 질문번호
      discType: 'I', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_9_i.png', // 이미지 경로
    },
    {
      questionNo: 9, // 질문번호
      discType: 'C', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_9_c.png', // 이미지 경로
    },
    {
      questionNo: 9, // 질문번호
      discType: 'S', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_9_s.png', // 이미지 경로
    },
    {
      questionNo: 9, // 질문번호
      discType: 'D', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_9_d.png', // 이미지 경로
    },
  ],
  10: [
    {
      questionNo: 10, // 질문번호
      discType: 'C', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_10_c.png', // 이미지 경로
    },
    {
      questionNo: 10, // 질문번호
      discType: 'I', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_10_i.png', // 이미지 경로
    },
    {
      questionNo: 10, // 질문번호
      discType: 'D', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_10_d.png', // 이미지 경로
    },
    {
      questionNo: 10, // 질문번호
      discType: 'S', // 타입(D|I|S|C)
      imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_10_s.png', // 이미지 경로
    },
  ],
  // 11: [
  //   {
  //     questionNo: 11, // 질문번호
  //     discType: 'A', // 타입(D|I|S|C)
  //     imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_11_a.png', // 이미지 경로
  //   },
  //   {
  //     questionNo: 11, // 질문번호
  //     discType: 'B', // 타입(D|I|S|C)
  //     imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_11_b.png', // 이미지 경로
  //   },
  //   {
  //     questionNo: 11, // 질문번호
  //     discType: 'C', // 타입(D|I|S|C)
  //     imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_11_c.png', // 이미지 경로
  //   },
  //   {
  //     questionNo: 11, // 질문번호
  //     discType: 'D', // 타입(D|I|S|C)
  //     imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_11_d.png', // 이미지 경로
  //   },
  // ],
  // 12: [
  //   {
  //     questionNo: 12, // 질문번호
  //     discType: 'A', // 타입(D|I|S|C)
  //     imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_12_a.png', // 이미지 경로
  //   },
  //   {
  //     questionNo: 12, // 질문번호
  //     discType: 'B', // 타입(D|I|S|C)
  //     imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_12_b.png', // 이미지 경로
  //   },
  //   {
  //     questionNo: 12, // 질문번호
  //     discType: 'C', // 타입(D|I|S|C)
  //     imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_12_c.png', // 이미지 경로
  //   },
  //   {
  //     questionNo: 12, // 질문번호
  //     discType: 'D', // 타입(D|I|S|C)
  //     imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_12_d.png', // 이미지 경로
  //   },
  // ],
  // 13: [
  //   {
  //     questionNo: 13, // 질문번호
  //     discType: 'A', // 타입(D|I|S|C)
  //     imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_13_a.png', // 이미지 경로
  //   },
  //   {
  //     questionNo: 13, // 질문번호
  //     discType: 'B', // 타입(D|I|S|C)
  //     imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_13_b.png', // 이미지 경로
  //   },
  //   {
  //     questionNo: 13, // 질문번호
  //     discType: 'C', // 타입(D|I|S|C)
  //     imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_13_c.png', // 이미지 경로
  //   },
  //   {
  //     questionNo: 13, // 질문번호
  //     discType: 'D', // 타입(D|I|S|C)
  //     imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_13_d.png', // 이미지 경로
  //   },
  // ],
  // 14: [
  //   {
  //     questionNo: 14, // 질문번호
  //     discType: 'A', // 타입(D|I|S|C)
  //     imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_14_a.png', // 이미지 경로
  //   },
  //   {
  //     questionNo: 14, // 질문번호
  //     discType: 'B', // 타입(D|I|S|C)
  //     imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_14_b.png', // 이미지 경로
  //   },
  //   {
  //     questionNo: 14, // 질문번호
  //     discType: 'C', // 타입(D|I|S|C)
  //     imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_14_c.png', // 이미지 경로
  //   },
  //   {
  //     questionNo: 14, // 질문번호
  //     discType: 'D', // 타입(D|I|S|C)
  //     imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_14_d.png', // 이미지 경로
  //   },
  // ],
  // 15: [
  //   {
  //     questionNo: 15, // 질문번호
  //     discType: 'A', // 타입(D|I|S|C)
  //     imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_15_a.png', // 이미지 경로
  //   },
  //   {
  //     questionNo: 15, // 질문번호
  //     discType: 'B', // 타입(D|I|S|C)
  //     imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_15_b.png', // 이미지 경로
  //   },
  //   {
  //     questionNo: 15, // 질문번호
  //     discType: 'C', // 타입(D|I|S|C)
  //     imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_15_c.png', // 이미지 경로
  //   },
  //   {
  //     questionNo: 15, // 질문번호
  //     discType: 'D', // 타입(D|I|S|C)
  //     imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_15_d.png', // 이미지 경로
  //   },
  // ],
  // 16: [
  //   {
  //     questionNo: 16, // 질문번호
  //     discType: 'A', // 타입(D|I|S|C)
  //     imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_16_a.png', // 이미지 경로
  //   },
  //   {
  //     questionNo: 16, // 질문번호
  //     discType: 'B', // 타입(D|I|S|C)
  //     imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_16_b.png', // 이미지 경로
  //   },
  //   {
  //     questionNo: 16, // 질문번호
  //     discType: 'C', // 타입(D|I|S|C)
  //     imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_16_c.png', // 이미지 경로
  //   },
  //   {
  //     questionNo: 16, // 질문번호
  //     discType: 'D', // 타입(D|I|S|C)
  //     imagePath: 'src/../assets/page/survey/DiscSurveyEditor/question_16_d.png', // 이미지 경로
  //   },
  // ],
};

// DISC 설문 결과 정보
const discSurveyResultDataList = {
  DD: {
    imagePath: 'src/../assets/page/survey/DiscSurveyResultEditor/result_d_d.png', // 이미지 경로
    mbti: 'ENTJ',
  },
  DI: {
    imagePath: 'src/../assets/page/survey/DiscSurveyResultEditor/result_d_i.png', // 이미지 경로
    mbti: 'ESTP',
  },
  DS: {
    imagePath: 'src/../assets/page/survey/DiscSurveyResultEditor/result_d_s.png', // 이미지 경로
    mbti: 'ENFJ',
  },
  DC: {
    imagePath: 'src/../assets/page/survey/DiscSurveyResultEditor/result_d_c.png', // 이미지 경로
    mbti: 'ESTJ',
  },
  ID: {
    imagePath: 'src/../assets/page/survey/DiscSurveyResultEditor/result_i_d.png', // 이미지 경로
    mbti: 'ENTP',
  },
  II: {
    imagePath: 'src/../assets/page/survey/DiscSurveyResultEditor/result_i_i.png', // 이미지 경로
    mbti: 'ESFP',
  },
  IS: {
    imagePath: 'src/../assets/page/survey/DiscSurveyResultEditor/result_i_s.png', // 이미지 경로
    mbti: 'ENFP',
  },
  IC: {
    imagePath: 'src/../assets/page/survey/DiscSurveyResultEditor/result_i_c.png', // 이미지 경로
    mbti: 'ESFJ',
  },
  SD: {
    imagePath: 'src/../assets/page/survey/DiscSurveyResultEditor/result_s_d.png', // 이미지 경로
    mbti: 'INTP',
  },
  SI: {
    imagePath: 'src/../assets/page/survey/DiscSurveyResultEditor/result_s_i.png', // 이미지 경로
    mbti: 'ISFP',
  },
  SS: {
    imagePath: 'src/../assets/page/survey/DiscSurveyResultEditor/result_s_s.png', // 이미지 경로
    mbti: 'INFP',
  },
  SC: {
    imagePath: 'src/../assets/page/survey/DiscSurveyResultEditor/result_s_c.png', // 이미지 경로
    mbti: 'ISFJ',
  },
  CD: {
    imagePath: 'src/../assets/page/survey/DiscSurveyResultEditor/result_c_d.png', // 이미지 경로
    mbti: 'INTJ',
  },
  CI: {
    imagePath: 'src/../assets/page/survey/DiscSurveyResultEditor/result_c_i.png', // 이미지 경로
    mbti: 'ISTP',
  },
  CS: {
    imagePath: 'src/../assets/page/survey/DiscSurveyResultEditor/result_c_s.png', // 이미지 경로
    mbti: 'INFJ',
  },
  CC: {
    imagePath: 'src/../assets/page/survey/DiscSurveyResultEditor/result_c_c.png', // 이미지 경로
    mbti: 'ISTJ',
  },
};

// DISC 설문 정보 클린
const asyncClearDiscSurvey = async () => {
  let discSurveyAnswerList = [];
  await storageHelper.asyncSet('discSurveyAnswerList', discSurveyAnswerList);
};

// DISC 설문 질문 항목 겟 (랜덤) [질문번호 단위. 질문당 4개 선택지 존재.]
const asyncGetDiscSurveyQuestionItemRandom = async () => {
  let discSurveyAnswerList = await storageHelper.asyncGet('discSurveyAnswerList');
  if (discSurveyAnswerList) {
  } else {
    discSurveyAnswerList = [];
  }

  let questionNo;
  let discSurveyDataListLength = objectHelper.getPropertyNameList(discSurveyDataList).length;
  while (true) {
    questionNo = numericHelper.getRandom(1, discSurveyDataListLength);

    // 중복방지

    if (discSurveyAnswerList.length == 0) {
      break;
    }

    let isExist = false;
    for (let i = 0; i < discSurveyAnswerList.length; i++) {
      let item = discSurveyAnswerList[i];
      if (item.questionNo == questionNo) {
        isExist = true; // if exist, found break.
        break;
      } else {
      }
    }

    if (isExist) {
      // if exist
      continue; // next continue
    } else {
      break;
    }
  }

  let questionData = discSurveyDataList[questionNo];
  return questionData;
};

// DISC 설문지 응답 입력
const asyncPutDiscSurveyAnswer = async (questionNo, seqInQuestion, discType) => {
  let discSurveyAnswerList = await storageHelper.asyncGet('discSurveyAnswerList');
  if (discSurveyAnswerList) {
  } else {
    discSurveyAnswerList = [];
  }

  const discSurveyAnswerData = {
    questionNo: questionNo,
    seqInQuestion: seqInQuestion,
    discType: discType,
  };
  discSurveyAnswerList.push(discSurveyAnswerData);

  await storageHelper.asyncSet('discSurveyAnswerList', discSurveyAnswerList);
};

// DISC 설문 응답 정보를 유형별 총 갯수 순 정렬 후 겟
const getOrderedDiscSurveyAnswerTypeStaticsList = async () => {
  let discSurveyAnswerList = await storageHelper.asyncGet('discSurveyAnswerList');

  let discSurveyAnswerTypeStaticsData = {
    // 통계
    D: 0,
    I: 0,
    S: 0,
    C: 0,
  };
  for (let i = 0; i < discSurveyAnswerList.length; i++) {
    let item = discSurveyAnswerList[i];
    let discType = item.discType;
    discSurveyAnswerTypeStaticsData[discType] = discSurveyAnswerTypeStaticsData[discType] + 1;
  }

  let orderedDiscSurveyAnswerTypeStaticsList = [
    // 0: 'D',
    // 4: 'C',
    // 6: 'S',
  ];
  let propertyNameList = objectHelper.getPropertyNameList(discSurveyAnswerTypeStaticsData);
  for (let i = 0; i < propertyNameList.length; i++) {
    let propertyName = propertyNameList[i];
    let propertyValue = discSurveyAnswerTypeStaticsData[propertyName];
    if (propertyValue == null || propertyValue == 0) {
      continue;
    } else {
    }
    orderedDiscSurveyAnswerTypeStaticsList[propertyValue] = propertyName;
  }
  return orderedDiscSurveyAnswerTypeStaticsList;
};

// DISC 설문 결과 겟
const asyncGetSurveyResult = async () => {
  let orderedDiscSurveyAnswerTypeStaticsList = await getOrderedDiscSurveyAnswerTypeStaticsList();
  let type1;
  let type2;
  for (let i = orderedDiscSurveyAnswerTypeStaticsList.length - 1; i > 0; i--) {
    let item = orderedDiscSurveyAnswerTypeStaticsList[i];
    if (item == null) {
      continue;
    }

    if (type1 == null) {
      type1 = item;
      continue;
    }
    if (type2 == null) {
      type2 = item;
      break;
    }
  }

  if (type2) {
  } else {
    type2 = type1;
  }
  let type = type1 + type2;

  let surveyResult = discSurveyResultDataList[type];
  if (surveyResult == undefined) {
    surveyResult = {
      imagePath: '', // 이미지 경로
      mbti: '',
    };
  }
  return surveyResult;
};

// =================================================================================================
// 내보내기
// =================================================================================================
export default {
  asyncGetDiscSurveyQuestionItemRandom,
  asyncClearDiscSurvey,
  asyncPutDiscSurveyAnswer,
  asyncGetSurveyResult,
};
